import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.jpg";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="main-navbar navbar navbar-expand-lg">
      <div className="container">

        {/* LOGO */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src={logo} alt="Logo" className="logo-img" />
        </Link>

        {/* TOGGLE BUTTON */}
        <button
          className={`navbar-toggler ${menuOpen ? "open" : ""}`}
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* MENU */}
        <div className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}>
          <ul className="navbar-nav menu-list ms-auto">

            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/men" onClick={() => setMenuOpen(false)}>For Men</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/women" onClick={() => setMenuOpen(false)}>For Women</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/couples" onClick={() => setMenuOpen(false)}>For Couples</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link login-btn" to="/admin/login" onClick={() => setMenuOpen(false)}>Login</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link contact-btn" to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</Link>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
